import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {
    IOrganizationAccountTableColumn,
    OrganizationAccount
} from '../types';
import {OrganizationAccountStatusBadge} from '../profile/OrganizationAccountStatusBadge';

export const columns = [
    {
        title: I18n.get('Account'),
        width: '1fr',
        render: (item: OrganizationAccount) => <NavLink
            to={`/accounts/${item.accountId}`}>{item.account ? item.account.email : item.accountId}</NavLink>,
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: OrganizationAccount) => <OrganizationAccountStatusBadge record={item}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: OrganizationAccount) => formatTimestamp(item.created as string),
    },
] as IOrganizationAccountTableColumn[];
